import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import { MdMoreVert } from "@react-icons/all-files/md/MdMoreVert";
import ModalWithInput from "./Modal/ModalWithInput";
import RemoveModal from "./Modal/RemoveModal";
import { randomId } from "../utils";

type Props = {
  value: string;
  index: number;
  onEdit: (index: number, name: string) => void;
  onRemove: (index: number) => void;
  withNumber: boolean;
  isLastElement?: boolean;
};

const ListItem = (props: Props) => {
  const {
    value,
    index,
    withNumber,
    onEdit,
    onRemove,
    isLastElement = false,
  } = props;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [bikerName, setBikerName] = useState("");
  const id = randomId();

  const onCloseEditModal = () => {
    setIsEditModalOpen(false);
    setBikerName("");
  };

  return (
    <div
      className={`h-16 p-4 ${
        !isLastElement && "mb-2"
      } flex flex-row items-center justify-between rounded bg-gray-100 border border-1 border-solid border-gray-300`}
    >
      <div className="flex flex-row items-center">
        {withNumber ? <h2 className="mr-1 font-bold">{index}º </h2> : null}
        <h2>{value}</h2>
      </div>
      <button
        data-tooltip-id={`options-${id}`}
        className="bg-transparent"
        onClick={() => setIsTooltipOpen(!isTooltipOpen)}
      >
        <MdMoreVert />
      </button>
      <Tooltip
        id={`options-${id}`}
        place="bottom"
        openOnClick
        clickable
        variant="light"
        className="tooltip"
        setIsOpen={setIsTooltipOpen}
        isOpen={isTooltipOpen}
      >
        <div className="flex flex-col justify-center">
          <p
            className="text-red-600 cursor-pointer mb-2"
            onClick={() => setIsRemoveModalOpen(true)}
          >
            Excluir
          </p>
          <p
            className="cursor-pointer"
            onClick={() => setIsEditModalOpen(true)}
          >
            Mudar nome
          </p>
        </div>
      </Tooltip>
      <ModalWithInput
        onChange={(event) => setBikerName(event.target.value)}
        onClose={onCloseEditModal}
        onSubmit={() => onEdit(index - 1, bikerName)}
        isOpen={isEditModalOpen}
        inputLabel="Nome"
        buttonLabel="Editar"
      />
      <RemoveModal
        onClose={() => setIsRemoveModalOpen(false)}
        onConfirm={() => onRemove(index - 1)}
        isOpen={isRemoveModalOpen}
        title="Tem certeza que quer excluir?"
        description="O nome vai ser removido da lista e não tem como desfazer esta ação."
        buttonLabel="Excluir"
      />
    </div>
  );
};

export default ListItem;
